import { TDates } from '../../../types';
import { parseTimeString } from '../parseTimeString';

export default (dates?: TDates) => {
  if (!dates || !dates?.startDate || !dates?.startTime) return undefined;

  const date = new Date(dates.startDate);
  if (isNaN(date.getTime())) return undefined;

  const isoString = date.toISOString();
  const time = parseTimeString(dates.startTime);

  return new Date(`${isoString.split('T')[0]}T${time}Z`);
};
